$(document).ready(function(){

	$('.btn--share').on('click', function(){
		$('.form__notifications .success, .form__notifications .error').html('').fadeOut();
		$('.popup.type--share').addClass('open');
	});

	$('.popup.type--share .btn--close').on('click', function(){
		$('.popup.type--share').removeClass('open');
	});

	$(document).on('mouseup', function(e) {
	  var container = $('.popup .inner');
	  if (!container.is(e.target) && container.has(e.target).length === 0) {
			$('.popup').removeClass('open');
	  }
	});

});